import { mailtoBugReport } from "util";

import { useEffect } from "react";
import Alert from "react-bootstrap/Alert";
import ReactGA from "react-ga4";
import { isRouteErrorResponse, useRouteError, Link } from "react-router-dom";

const ErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      ReactGA.event({ action: error.message, category: "Error", label: "Router" });
    } else {
      ReactGA.event({ action: error.message, category: "Errors", label: "ErrorBoundary" });
    }
  }, []);

  if (isRouteErrorResponse(error)) {
    return (
      <Alert className="m-4" variant="danger">
        <h4>{error.status}</h4>
        <p className="mb-0">{error?.message}</p>
      </Alert>
    );
  } else {
    const stack = error.stack || error.message;
    return (
      <Alert className="m-4" variant="danger">
        <h4>An error occurred</h4>
        <p className="mb-2">Something went wrong, and our team has been automatically notified.</p>
        <code>{error.stack || error.message}</code>
        <p className="mb-0 mt-2">
          You can <Link to="/bug-report">submit a bug report</Link>, or email us at{" "}
          <Link target="_blank" to={mailtoBugReport(stack)}>
            bugreport@edhrec.com
          </Link>
          .
        </p>
      </Alert>
    );
  }
};

export default ErrorBoundary;
